import { useEffect } from 'react';
import { GATrackPageView } from '../gtag';

export function usePageView(title) {
  useEffect(() => {
    GATrackPageView(title);
  }, []);
}



// WEBPACK FOOTER //
// ./src/hocs/usePageView.js